// --- AppRouter (ocn-S184-P0) -------------------------------------
// Owns in-shell page rendering + the S182 user_tier ROUTE gate. App.tsx hands
// it the current `page` and a RouterCtx; AppRouter:
//   1. resolves the caller's user_tier (builder | developer, default builder),
//   2. blocks developer-only pages for builders (redirect to BUILDER_HOME),
//   3. otherwise delegates to the pageRegistry.
// Developer tier is always allowed -> behavior-preserving for developers.

import React, { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { isPageAllowedForTier, BUILDER_HOME } from "./tier-visibility";
import { renderPage, type RouterCtx } from "./pageRegistry";

export function AppRouter({ page, ctx }: { page: string; ctx: RouterCtx }) {
  const { userTier } = useAuth();
  const { go } = ctx;
  const allowed = isPageAllowedForTier(page, userTier);

  // A builder that lands on a developer-only page (e.g. a stale link or a
  // ?page= URL) is bounced to the builder home rather than rendering it.
  useEffect(() => {
    if (!allowed) go(BUILDER_HOME);
  }, [allowed, page, go]);

  if (!allowed) return null;
  return <>{renderPage(page, ctx)}</>;
}
